const CONFIGURED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const BACKEND_URL = process.env.NODE_ENV === "production" ? "" : CONFIGURED_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const authHeaders = (token) => ({
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export const getEnergyStatus = async (token) => {
  const res = await fetch(`${API}/energy/status`, { headers: authHeaders(token), credentials: "include" });
  if (!res.ok) throw new Error(`Failed to fetch energy status: ${res.status}`);
  return res.json();
};

export const getEnergyDevices = async (token) => {
  const res = await fetch(`${API}/energy/devices`, { headers: authHeaders(token), credentials: "include" });
  if (!res.ok) throw new Error(`Failed to fetch energy devices: ${res.status}`);
  return res.json();
};

export const getEnergyForecast = async (token) => {
  const res = await fetch(`${API}/energy/forecast`, { headers: authHeaders(token), credentials: "include" });
  if (!res.ok) throw new Error(`Failed to fetch energy forecast: ${res.status}`);
  return res.json();
};

export const optimizeEnergy = async (token) => {
  const res = await fetch(`${API}/energy/optimize`, {
    method: "POST",
    headers: authHeaders(token),
    credentials: "include",
  });
  const payload = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(payload.detail || "Energy optimization failed");
  return payload;
};